// src/pages/HRAdmin/Department/AddDepartmentPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  MenuItem
} from '@mui/material';

function AddDepartmentPage() {
  const navigate = useNavigate();
  const [managers, setManagers] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    description: '',
    manager_id: '',
    cost_center: '',
  });

  useEffect(() => {
    // Fetch potential managers if you want a dropdown
    api.get('/admin/users?role=manager')
      .then((res) => setManagers(res.data))
      .catch((err) => console.error('Failed to fetch managers:', err));
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .post('/admin/departments', formData)
      .then((res) => {
        navigate('/admin/departments');
      })
      .catch((err) => console.error('Error creating department:', err));
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Add New Department
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Department Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          fullWidth
          margin="normal"
        />
        <TextField
          label="Code"
          name="code"
          value={formData.code}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        {/* Manager dropdown */}
        <TextField
          label="Manager"
          name="manager_id"
          select
          value={formData.manager_id}
          onChange={handleChange}
          fullWidth
          margin="normal"
        >
          <MenuItem value="">No Manager</MenuItem>
          {managers.map((mgr) => (
            <MenuItem key={mgr.employee_code} value={mgr.employee_code}>
              {mgr.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Cost Center"
          name="cost_center"
          value={formData.cost_center}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button 
            variant="outlined" 
            color="inherit"
            onClick={() => navigate('/admin/departments')}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Save
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

export default AddDepartmentPage;
